export function toValidHTML (html: string): string {
  return html.replace(/<([a-z]*)(\s[^>]*?)?\/>/gi, (complete, tagName, attributes = '') => {
    const allowedSelfclosing: string[] = ['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']
    if (!allowedSelfclosing.includes(tagName.toLowerCase())) {
      return `<${tagName}${attributes}></${tagName}>`
    }
    return complete
  })
}
